module.exports = __webpack_public_path__ + "media/images/long-text-323ec6d812f33f43cc674e2f0394eae2.svg";